import React from 'react';
import ab from '../assets/ab.ico';
import ModernFooter from './modern/ModernFooter';

// Board-specific bits only; the design is shared (src/components/modern, 2026-10-02 refresh).
export default function Footer() {
  return <ModernFooter logo={<img src={ab} className="h-8 w-8" alt="" />} />;
}
